import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import {
  Button,
  Col,
  Modal,
  Container,
  Dropdown,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import {
  CASE_STAGE_STATUS,
  PICKLIST_GROUP_NAME,
  STAKEHOLDER_LIST_CODE,
  WEB_ROLE,
} from "../../../../common/Constant";
import {
  addCaseheaderDetails,
  fetchCaseheaderinfo,
  fetchCaseStakeholderDetails,
  fetchPickListByGroupName,
  fetchRegisterCaseButtonStatus,
  updateCaseheaderDetails,
} from "../../../../services/CaseInformationApi";
import TextInput from "../../../../common/PicklistTesxBox";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/Store";
import {
  setClaimNumber,
  setCaseId,
  setStatus,
  setCaseInfoId,
  setCaseStage,
  setCaseTypeName,
  setIsDashboard,
  setNewCaseInFoID,
} from "../../../../redux/slice/CaseHeaderSlice";
import Snackbar from "../../../../common/Snackbar";
import caseHeaderValidations from "../actions/CaseHeaderValidations";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import DataTable from "../../../../common/DataTable";
import { GENERAL_LOG_HEADERS } from "../actions/Constant";
import moment from "moment";
import { fetchSubjectInfo } from "../../../../services/Case_SubjectAPI";
import MultilineTextBox from "../../../../common/MultilineTextBox";
import Loader from "../../../../common/Loader";
import AccordionComponent from "../../../../common/Accordion";
import { updateCaseStageAction } from "../../../../services/ActivityUpdateApi";
import { fetchCaseStages } from "../../../../redux/slice/caseStagesSlice";
import { Archive } from "lucide-react";
import { CASE_ACTIONS } from "../../../../common/EventConstant";
import FloatingLabelDatepicker from "../../../../common/DatePicker";
import { useLocation, useNavigate } from "react-router-dom";

interface AddNewUserProps {
  userData: any;
  action: string;
  loggedInUserid: any;
  caseStageId: any;
  activeTab: string;
  onCancel: (action: string) => void;
  headerActiveTab: string;
  userRole: string;
}

const Header: React.FC<AddNewUserProps> = ({
  userData,
  action,
  loggedInUserid,
  caseStageId,
  activeTab,
  onCancel,
  headerActiveTab,
  userRole,
}) => {
  const isEditable = action !== "View";
  const isEditableNew = action === "Edit";
  const newStage = caseStageId.find(
    (item: { label: string }) => item.label === "New"
  );
  const registerStage = caseStageId.find(
    (item: { label: string }) => item.label === "Registered"
  );
  const dispatch = useDispatch();
  const dispatchNew = useDispatch<AppDispatch>();
  const { caseid, claimnumber, status, caseStage, caseInfoId, clientId } =
    useSelector((state: RootState) => state.caseHeader);
  const { view_Case } = useSelector((state: RootState) => state.featureAccess);
  const { currentStage } = useSelector((state: RootState) => state.caseStages);
  const [typeOptions, setTypeOptions] = useState<any[]>([]);
  const [priorityOptions, setPriorityOptions] = useState<any[]>([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [result, setResult] = useState<any>({});
  const [logdata, setLogdata] = useState<any[]>([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isRegister, setIsRegister] = useState(false);
  const [isRegisterButton, setIsRegisterButton] = useState(false);
  const [caseSubjectId, setCaseSubjectId] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const newID = userData?.caseInfoId || caseInfoId;
  const [stakeholderId, setStakeholderId] = useState<
    number | null | undefined | string
  >(null);
  const [ArChived, setArChived] = useState<number | null>(null);
  const [selectedCaseReviewTypeLabel, setSelectedCaseReviewTypeLabel] =
    useState("");
  const allowedFeatures = useSelector(
    (state: RootState) => state.featureAccess.allowedFeatures
  );

  const hasCaseActionAccess = Array.from(allowedFeatures).some((feature) =>
    Object.values(CASE_ACTIONS).includes(feature)
  );

  const fetchPickListData = async (id?: any) => {
    try {
      const responsePriority = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Case_Priority,
        triggerById: loggedInUserid,
      });
      const responseCaseType = await fetchPickListByGroupName({
        groupName: PICKLIST_GROUP_NAME.Case_Review_Type,
        triggerById: loggedInUserid,
      });
      const filteredTypes = responseCaseType?.filter(
        (item: any) =>
          item.label?.trim().toLowerCase() !== "unassigned case review type"
      );
      if (responseCaseType && responsePriority) {
        setPriorityOptions(responsePriority);
        setTypeOptions(filteredTypes);
      }
      let updatedCaseTypeOptions = filteredTypes || [];
      if (newID || id) {
        const headerInfo = await fetchCaseheaderinfo(newID || id);

        if (headerInfo) {
          setArChived(headerInfo.isArchive);
          setResult(headerInfo || {});
          setIsRegister(
            headerInfo?.caseStageName !== CASE_STAGE_STATUS.NEW ? true : false
          );
          const selectedOption = typeOptions.find(
            (opt) => opt.value === headerInfo.caseReviewTypeId
          );
          setSelectedCaseReviewTypeLabel(selectedOption?.label || "");
          const claimNumber =
            headerInfo?.claimNumber &&
            headerInfo.claimNumber?.startsWith("UnAssigned Claim")
              ? ""
              : result?.claimNumber || "";
          if (
            !userData?.caseInfoId &&
            headerInfo.claimNumber?.startsWith("UnAssigned Claim")
          ) {
            dispatch(setCaseId(headerInfo?.caseId));
            dispatch(setClaimNumber(claimNumber));
          }
          dispatch(setCaseStage(headerInfo?.caseStageName));
          dispatch(setCaseInfoId(headerInfo?.caseInfoId));
          dispatchNew(fetchCaseStages(headerInfo?.caseInfoId));
          dispatch(setCaseTypeName(headerInfo?.caseReviewTypeName));
          setLogdata([
            {
              createdDate: moment(headerInfo.createdDate).format(
                "MM/DD/YYYY | hh:mm A"
              ),
              modifiedDate: moment(headerInfo.modifiedDate).format(
                "MM/DD/YYYY | hh:mm A"
              ),
              createdByName: headerInfo.createdByName,
              modifiedByName: headerInfo.modifiedByName,
            },
          ]);

          if (
            headerInfo.caseReviewTypeId &&
            !updatedCaseTypeOptions.some(
              (type: any) => type.value === headerInfo.caseReviewTypeId
            ) &&
            headerInfo.caseReviewTypeName?.trim().toLowerCase() !==
              "unassigned case review type"
          ) {
            updatedCaseTypeOptions.push({
              value: headerInfo.caseReviewTypeId,
              label: headerInfo.caseReviewTypeName,
            });
          }
        }
      }
      setTypeOptions(removeDuplicates(updatedCaseTypeOptions));
    } catch (error) {
      console.error("Error fetching picklist data:", error);
    } finally {
      setLoading(false);
    }
  };

  const removeDuplicates = (options: any[]) => {
    return Array.from(
      new Map(options.map((item) => [item.value, item])).values()
    );
  };

  useEffect(() => {
    if(headerActiveTab !== "Header") return;
    fetchPickListData();
  }, [headerActiveTab]);

  // const fetchCaseStakeholderDetailsData = async () => {
  //   try {
  //     if (caseInfoId && caseInfoId !== null && caseInfoId !== undefined) {
  //       const stakeholderData = await fetchCaseStakeholderDetails(
  //         caseInfoId,
  //         STAKEHOLDER_LIST_CODE.PRACTICE_MANAGEMENT_COMPANY
  //       );
  //       setStakeholderId(stakeholderData[0]?.stakeholderId || null);
  //     } else {
  //       setStakeholderId(null);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching while data getting:", error);
  //   }
  // };

  // useEffect(() => {
  //   if (caseInfoId && caseInfoId !== null && caseInfoId !== undefined) {
  //     fetchCaseStakeholderDetailsData();
  //   }
  // }, [caseInfoId, headerActiveTab, activeTab]);

  const initialValues = {
    caseid: result?.caseId || null,
    dateOfRegistration: isRegister ? result?.dateOfRegistration : null,
    priorityid:
      result?.priorityId ||
      priorityOptions.find((option) => option.label === "Normal")?.value ||
      "",
    casereviewtypeid:
      result?.claimNumber && result.claimNumber?.startsWith("UnAssigned Claim")
        ? ""
        : result?.caseReviewTypeId || "",
    claimnumber:
      result?.claimNumber && result.claimNumber?.startsWith("UnAssigned Claim")
        ? ""
        : result?.claimNumber || "",
    wcabnumber: result?.wcabNumber || "",
    panelnumber: result?.panelNumber || "",
    filenumber: result?.fileNumber || "",
    adjnumber: result?.adjNumber || "",
    casenumber: result?.caseNumber || "",
    casename: result?.caseName || "",
    casestageid: result?.caseStageId || "",
    additionalcomments: result?.additionalComments || "",
  };

  const handleSubmit = async (
    values: any,
    isRegister: boolean,
    claimNumberLabel: any
  ) => {
    const newError = await caseHeaderValidations(values, claimNumberLabel);
    // Check if there are any errors
    if (newError && Object.keys(newError).length > 0) {
      const errorFields = Object.values(newError);
      const errorMessage = errorFields.join("\n");
      setSnackbarMessage(errorMessage);
      setError("error");
      setSnackbarOpen(true);
    } else {
      try {
        setLoading(true);

        const payloadAdd = {
          priorityid: values.priorityid,
          casereviewtypeid: values.casereviewtypeid,
          claimnumber: values.claimnumber?.length
            ? values.claimnumber?.trim()
            : null,
          wcabnumber: values.wcabnumber?.length
            ? values.wcabnumber?.trim()
            : null,
          panelnumber: values.panelnumber?.length
            ? values.panelnumber?.trim()
            : null,
          filenumber: values.filenumber?.length
            ? values.filenumber?.trim()
            : null,
          adjnumber: values.adjnumber?.length ? values.adjnumber?.trim() : null,
          casenumber: values.casenumber?.length
            ? values.casenumber?.trim()
            : null,
          casename: values.casename?.length ? values.casename?.trim() : null,
          casestageid: newStage?.value,
          additionalcomments: values.additionalcomments?.trim(),
          createdby: loggedInUserid,
        };

        const payloadUpdate = {
          caseinfoid: result?.caseInfoId,
          priorityid: values.priorityid,
          casereviewtypeid: values.casereviewtypeid,
          claimnumber: values.claimnumber?.length
            ? values.claimnumber?.trim()
            : null,
          wcabnumber: values.wcabnumber?.length
            ? values.wcabnumber?.trim()
            : null,
          panelnumber: values.panelnumber?.length
            ? values.panelnumber?.trim()
            : null,
          filenumber: values.filenumber?.length
            ? values.filenumber?.trim()
            : null,
          adjnumber: values.adjnumber?.length ? values.adjnumber?.trim() : null,
          casenumber: values.casenumber?.length
            ? values.casenumber?.trim()
            : null,
          casename: values.casename?.length ? values.casename?.trim() : null,
          casestageid: result?.caseStageId
            ? result?.caseStageId
            : newStage?.value,
          additionalcomments: values.additionalcomments?.trim(),
          modifiedby: loggedInUserid,
        };
        const handleResponse = (
          response: any,
          successMessage: any,
          errorMessage: any
        ) => {
          if (response && response?.isSuccess) {
            setSnackbarMessage(successMessage);
            setError("success");
            setSnackbarOpen(true);
            fetchPickListData();
          } else {
            setSnackbarMessage(errorMessage.replace(/[\r\n]+$/, ""));
            setError("error");
            setSnackbarOpen(true);
          }
        };

        let response;
        if (result?.caseInfoId) {
          // Update case header details
          response = await updateCaseheaderDetails(payloadUpdate);

          handleResponse(
            response,
            "Case Information saved successfully.",
            response?.message
          );

          if (response?.isSuccess) {
            dispatch(setClaimNumber(values.claimnumber));
            dispatchNew(fetchCaseStages(result?.caseInfoId));
          }
        }

        // if (result?.caseInfoId) {
        //   // Update data
        //   if (isRegister) {
        //     response = await fetchRegisterCaseButtonStatus(newID);
        //     handleResponse(
        //       response,
        //       "Case registered successfully.",
        //       response?.message
        //     );
        //     if (response?.message) {
        //       fetchPickListData();
        //     }
        //   } else {
        //     response = await updateCaseheaderDetails(payloadUpdate);
        //     handleResponse(
        //       response,
        //       "Case Information saved successfully.",
        //       response?.message
        //     );
        //   }
        //   if (response?.isSuccess) {
        //     dispatch(setClaimNumber(values.claimnumber));
        //     dispatchNew(fetchCaseStages(result?.caseInfoId));
        //   }
        // }
        // else {
        //   // Add New data
        //   response = await addCaseheaderDetails(payloadAdd);
        //   handleResponse(
        //     response,
        //     'Case Information saved successfully.',
        //     response?.message,
        //   );
        // }
      } catch (error) {
        console.error("Error during API call:", error);
      } finally {
        setLoading(false);
      }
    }

    dispatch(setStatus(false));
  };

  const location = useLocation();
  const navigate = useNavigate();
  const isFromRecordReviewer = location.state?.from === "mytodos";
  const isFromAppointment = location.state?.from === "appointment";

  const handleReviewerBack = () => {
    dispatch(setIsDashboard(false));
    dispatch(setNewCaseInFoID(null));
    navigate("/mytodos", {
      state: location.state,
    });
  };

  const handleAppointmentTabBack = () => {
    dispatch(setIsDashboard(false));
    dispatch(setNewCaseInFoID(null));
    navigate("/appointment", {
      state: location.state,
    });
  };

  const handleBack = () => {
    onCancel("Cancel");
  };

  const handleNavigationBack = () => {
    if (isFromRecordReviewer) {
      handleReviewerBack();
    } else if (isFromAppointment) {
      handleAppointmentTabBack();
    } else {
      handleBack();
    }
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
  };
  const [showTooltip, setShowTooltip] = useState(false);

  const handleOpenDrawer = () => {
    setDrawerOpen(true);
    setShowTooltip(false);
  };

  const [caseInfoKey, setcaseInfoKey] = useState<string | null>("0");

  const caseInfoAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={caseInfoKey}
      onSelect={(key) => setcaseInfoKey(key as string)}
    />
  );

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedAction, setSelectedAction] = useState<ActionType | null>(null);

  const [actionReason, setActionReason] = useState("");
  type ActionType =
    | "OnHold"
    | "Resumed"
    | "Cancelled"
    | "Closed"
    | "Archived"
    | "Unarchived";

  const handleAction = async (actionType: ActionType, reason: string) => {
    try {
      const response = await updateCaseStageAction(
        caseInfoId,
        actionType,
        reason
      );
      setSnackbarMessage(response.result || "Action completed successfully");
      setError("success");
      setSnackbarOpen(true);
      if (response?.isSuccess && response?.statusCode == 200) {
        dispatchNew(fetchCaseStages(caseInfoId));
        fetchPickListData();
      }
    } catch (err) {
      setSnackbarMessage("Something went wrong!");
      setError("error");
      setSnackbarOpen(true);
    }
  };

  const [showReasonError, setShowReasonError] = useState(false);
  const confirmAndExecute = () => {
    if (!actionReason.trim()) {
      setShowReasonError(true);
      return;
    }

    handleAction(selectedAction as ActionType, actionReason);
    setShowConfirmModal(false);
    setActionReason("");
    setShowReasonError(false);
  };

  type CaseStageStatus =
    (typeof CASE_STAGE_STATUS)[keyof typeof CASE_STAGE_STATUS];
  const actionVisibilityMap: Record<string, string[]> = {
    [CASE_STAGE_STATUS.REGISTERED]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.SCHEDULE]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.DOCUMENTPREPARATION]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.SCHEDULING]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.EVALUATION]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.DRAFTINGREPORT]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.REPORTRIVIEW]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.REPORTFINALIZE]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.BILLING]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.PAYMENTPENDING]: ["OnHold", "Closed", "Cancelled"],

    [CASE_STAGE_STATUS.PAYMENTCOMPLETE]: ["OnHold", "Closed", "Cancelled"],

    [CASE_STAGE_STATUS.DESPOSITION]: ["OnHold", "Closed", "Cancelled"],

    [CASE_STAGE_STATUS.REGISTEREDONHOLD]: [
      "Resumed",
      "Closed",
      // "Archived",
      // "Cancelled",
    ],
    [CASE_STAGE_STATUS.PAYMENTPENDINGONHOLD]: [
      "Resumed",
      "Closed",
      "Cancelled",
    ],
    [CASE_STAGE_STATUS.SCHEDULEONHOLD]: ["OnHold", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.DOCUMENTPREPARATIONONHOLD]: [
      "Resumed",
      "Closed",

      "Cancelled",
    ],
    [CASE_STAGE_STATUS.DESPOSITIONHOLD]: ["Resumed", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.SCHEDULINGONHOLD]: ["Resumed", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.EVALUATIONONHOLD]: ["Resumed", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.DRAFTINGREPORTONHOLD]: [
      "Resumed",
      "Closed",
      "Cancelled",
    ],
    [CASE_STAGE_STATUS.REPORTRIVIEWONHOLD]: ["Resumed", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.REPORTFINALIZEONHOLD]: [
      "Resumed",
      "Closed",
      "Cancelled",
    ],
    [CASE_STAGE_STATUS.BILLINGONHOLD]: ["Resumed", "Closed", "Cancelled"],
    [CASE_STAGE_STATUS.PAYMENTCOMPLETEONHOLD]: [
      "Resumed",
      "Closed",

      "Cancelled",
    ],
    [CASE_STAGE_STATUS.COMPLIANCEREVIEWONHOLD]: [
      "Resumed",
      "Closed",

      "Cancelled",
    ],

    [CASE_STAGE_STATUS.RESUME]: ["OnHold", "Cancelled", "Closed"],
    [CASE_STAGE_STATUS.CANCELLED]: ["Archived"],
    [CASE_STAGE_STATUS.CLOSED]: ["Archived"],
    [CASE_STAGE_STATUS.ARCHIVED]: ["Cancelled", "Closed", "Unarchived"],
    [CASE_STAGE_STATUS.UNARCHIVED]: ["Archived"],
  };
  const visibleActions = actionVisibilityMap[currentStage] || [];

  if (ArChived === 1 && !visibleActions.includes("Unarchived")) {
    visibleActions.push("Unarchived");
  }

  const allowedRoles = [WEB_ROLE.Case_Manager, WEB_ROLE.App_Admin];

  const canEditCase = allowedRoles.includes(userRole);

  const isSIBTFSelected = selectedCaseReviewTypeLabel
    ?.toLowerCase()
    .includes("sibtf");
  const claimNumberLabel = isSIBTFSelected
    ? "SIBTF Case Number"
    : "Case Number";

  return (
    <div>
      <Container fluid className="pb-4 px-0 position-relative action-dropdown">
        <Loader isLoading={loading} />
        {currentStage !== CASE_STAGE_STATUS.NEW && hasCaseActionAccess && (
          <Dropdown
            className="mb-3 position-absolute"
            style={{
              position: "absolute",
              right: "36px",
              width: "100px",
              top: "-50px",
            }}
          >
            <Dropdown.Toggle
              variant="primary"
              id="dropdown-actions"
              className="d-flex align-items-center action-btn "
            >
              <span className="material-symbols-outlined material-icons me-1">
                settings
              </span>
              Case Actions
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {visibleActions.includes("OnHold") && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("OnHold");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center border-bottom"
                >
                  <span className="material-icons me-2 theme-color">
                    pause_circle
                  </span>
                  On Hold
                </Dropdown.Item>
              )}

              {visibleActions.includes("Resumed") && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("Resumed");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center border-bottom"
                >
                  <span className="material-icons me-2 theme-color ">
                    play_arrow
                  </span>
                  Resume
                </Dropdown.Item>
              )}

              {visibleActions.includes("Cancelled") && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("Cancelled");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center border-bottom"
                >
                  <span className="material-icons me-2 theme-color ">
                    cancel
                  </span>
                  Cancel
                </Dropdown.Item>
              )}

              {visibleActions.includes("Closed") && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("Closed");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center "
                >
                  <span className="material-icons me-2 theme-color">close</span>
                  Close
                </Dropdown.Item>
              )}

              {visibleActions.includes("Archived") && ArChived === 0 && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("Archived");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center"
                >
                  <span className="material-icons me-2 text-info">archive</span>
                  Archive
                </Dropdown.Item>
              )}

              {visibleActions.includes("Unarchived") && ArChived === 1 && (
                <Dropdown.Item
                  onClick={() => {
                    setSelectedAction("Unarchived");
                    setShowConfirmModal(true);
                  }}
                  className="d-flex align-items-center"
                >
                  <span className="material-icons me-2 text-success">
                    unarchive
                  </span>
                  Un-archive
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        )}

        <Modal
          show={showConfirmModal}
          onHide={() => {
            setShowConfirmModal(false);
            setActionReason("");
            setShowReasonError(false);
          }}
          centered
          className="recordList"
        >
          <Modal.Header closeButton className="d-flex">
            <Modal.Title className="fw-bold text-left modelheading offcanvas-title d-flex align-items-center">
              Are you sure you want to{" "}
              {selectedAction === "OnHold"
                ? "put the case on hold"
                : `perform the "${selectedAction}" action`}
              ?
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>
              {selectedAction?.toLowerCase() === "cancelled" ? (
                <>
                  Appointments scheduled during this time span will be cancelled{" "}
                  <br />
                  Please specify the reason for cancellation
                </>
              ) : selectedAction?.toLowerCase() === "closed" ? (
                <>
                  Appointments scheduled during this time span will be closed{" "}
                  <br />
                  Are you sure you want to perform the closed action?
                </>
              ) : (
                `Are you sure you want to perform the "${selectedAction}" action?`
              )}
            </p>
            <div className="mb-3">
              <label htmlFor="actionReason" className="form-label">
                Reason <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                id="actionReason"
                className={`form-control ${
                  showReasonError ? "is-invalid" : ""
                }`}
                rows={3}
                value={actionReason}
                onChange={(e) => {
                  setActionReason(e.target.value);
                  setShowReasonError(false); // clear error on change
                }}
                placeholder="Enter reason here"
              />
              {showReasonError && (
                <div className="invalid-feedback">Reason is required.</div>
              )}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowConfirmModal(false);
                setActionReason("");
                setShowReasonError(false);
              }}
              className="d-flex align-items-center"
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={confirmAndExecute}
              variant="primary"
              className="ms-3 d-flex align-items-center"
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        <Formik
          initialValues={initialValues}
          onSubmit={(values) =>
            handleSubmit(values, isRegisterButton, claimNumberLabel)
          }
          enableReinitialize
        >
          {({ values, handleChange, setFieldValue, resetForm, dirty }) => (
            <Form className="pb-3">
              {caseInfoAccordion([
                {
                  title: "Case Information",
                  content: (
                    <>
                      <Row>
                        <Col sm={3}>
                          <TextInput
                            label="Case ID"
                            name="caseid"
                            value={values.caseid || caseid}
                            onChange={handleChange}
                            disabled
                          />
                        </Col>
                        <Col sm={3}>
                          <FloatingLabelDatepicker
                            label="Date of Registration"
                            name="dateOfRegistration"
                            value={
                              values.dateOfRegistration
                                ? new Date(values.dateOfRegistration)
                                : null
                            }
                            onChange={handleChange}
                            dateFormat="MM/dd/yyyy"
                            disabled
                          />
                        </Col>
                        <Col sm={3} className="d-flex align-items-center">
                          <div className="d-flex gap-3 mt-2">
                            <label className="me-2">
                              Priority <span style={{ color: "red" }}>*</span>
                            </label>
                            {priorityOptions.map((option) => (
                              <label key={option.value}>
                                <Field
                                  type="radio"
                                  name="priorityid"
                                  value={option.value}
                                  checked={values.priorityid === option.value}
                                  onChange={() =>
                                    setFieldValue("priorityid", option.value)
                                  }
                                  disabled={
                                    !canEditCase &&
                                    (!isEditable || isRegister || view_Case)
                                  }
                                />
                                <span className="ms-1">{option.label}</span>
                              </label>
                            ))}
                          </div>
                        </Col>

                        <Col sm={3} className="selection_dropdown">
                          <SearchableSingleSelectDropdown
                            label="Case (Review) Type"
                            value={values.casereviewtypeid}
                            options={typeOptions}
                            name="casereviewtypeid"
                            required={true}
                            onChange={(e) => {
                              handleChange(e);
                              const selectedOption = typeOptions.find(
                                (opt) => opt.value === e.target.value
                              );
                              setSelectedCaseReviewTypeLabel(
                                selectedOption?.label || ""
                              );
                            }}
                            disabled={
                              (!canEditCase &&
                                (!isEditable || isRegister || view_Case)) ||
                              currentStage !== CASE_STAGE_STATUS.NEW
                            }
                          />
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm={3}>
                          <TextInput
                            label="Claim Number"
                            name="claimnumber"
                            value={values.claimnumber}
                            onChange={(e) => {
                              const regex = /^[a-zA-Z0-9\-\/_#\.]*$/;
                              if (
                                regex.test(e.target.value) ||
                                e.target.value === ""
                              ) {
                                handleChange(e);
                              }
                            }}
                            maxLength={50}
                            required={true}
                            disabled={
                              !canEditCase &&
                              (!isEditable || isRegister || view_Case)
                            }
                          />
                        </Col>
                        <Col sm={3}>
                          <TextInput
                            label="ADJ/WCAB No"
                            name="wcabnumber"
                            value={values.wcabnumber}
                            onChange={(e) => {
                              let value = e.target.value;
                              const regex = /^[a-zA-Z0-9\-\/_#\. ]*$/;
                              if (!regex.test(value)) return;
                              if (value.startsWith(" ")) return;
                              value = value.replace(/\s{2,}/g, " ");
                              e.target.value = value;
                              handleChange(e);
                            }}
                            maxLength={50}
                            disabled={
                              !canEditCase &&
                              (!isEditable || isRegister || view_Case)
                            }
                          />
                        </Col>
                        <Col sm={3}>
                          <TextInput
                            label="Panel No"
                            name="panelnumber"
                            value={values.panelnumber}
                            onChange={(e) => {
                              let value = e.target.value;
                              const regex = /^[a-zA-Z0-9\-\/_#\. ]*$/;
                              if (!regex.test(value)) return;
                              if (value.startsWith(" ")) return;
                              value = value.replace(/\s{2,}/g, " ");
                              e.target.value = value;
                              handleChange(e);
                            }}
                            maxLength={50}
                            disabled={
                              !canEditCase &&
                              (!isEditable || isRegister || view_Case)
                            }
                          />
                        </Col>
                        <Col sm={3}>
                          <TextInput
                            label="File No"
                            name="filenumber"
                            value={values.filenumber}
                            onChange={(e) => {
                              let value = e.target.value;
                              const regex = /^[a-zA-Z0-9\-\/_#\. ]*$/;
                              if (!regex.test(value)) return;
                              if (value.startsWith(" ")) return;
                              value = value.replace(/\s{2,}/g, " ");
                              e.target.value = value;
                              handleChange(e);
                            }}
                            maxLength={50}
                            disabled={
                              !canEditCase &&
                              (!isEditable || isRegister || view_Case)
                            }
                          />
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        {/* <Col sm={3}>
                          <TextInput
                            label="ADJ No"
                            name="adjnumber"
                            value={values.adjnumber}
                            onChange={(e) => {
                              let value = e.target.value;
                              const regex = /^[a-zA-Z0-9\-\/_#\. ]*$/;
                              if (!regex.test(value)) return;
                              if (value.startsWith(" ")) return;
                              value = value.replace(/\s{2,}/g, " ");
                              e.target.value = value;
                              handleChange(e);
                            }}
                            maxLength={50}
                            disabled={!isEditable || isRegister || view_Case}
                          />
                        </Col> */}
                        <Col sm={3}>
                          <TextInput
                            label={claimNumberLabel}
                            name="casenumber"
                            value={values.casenumber}
                            onChange={(e) => {
                              let value = e.target.value;
                              const regex = /^[a-zA-Z0-9\-\/_#\. ]*$/;
                              if (!regex.test(value)) return;
                              if (value.startsWith(" ")) return;
                              value = value.replace(/\s{2,}/g, " ");
                              e.target.value = value;
                              handleChange(e);
                            }}
                            required={
                              claimNumberLabel == "SIBTF Case Number"
                                ? true
                                : false
                            }
                            maxLength={50}
                            disabled={
                              !canEditCase &&
                              (!isEditable || isRegister || view_Case)
                            }
                          />
                        </Col>
                        <Col sm={6}>
                          <TextInput
                            label="Case Name"
                            name="casename"
                            value={values.casename}
                            onChange={(e) => {
                              let value = e.target.value;
                              const regex = /^[a-zA-Z0-9\-\/_#\. ]*$/;
                              if (!regex.test(value)) return;
                              if (value.startsWith(" ")) return;
                              value = value.replace(/\s{2,}/g, " ");
                              e.target.value = value;
                              handleChange(e);
                            }}
                            maxLength={200}
                            disabled={
                              !canEditCase &&
                              (!isEditable || isRegister || view_Case)
                            }
                          />
                        </Col>
                      </Row>

                      <Row className="mt-3">
                        <Col sm={12}>
                          <MultilineTextBox
                            label="Comments"
                            name="additionalcomments"
                            value={values.additionalcomments}
                            onChange={(e) => {
                              let value = e.target.value;
                              if (value.startsWith(" ")) return;
                              value = value?.trimStart();
                              value = value.replace(/ {2,}/g, " ");
                              e.target.value = value;
                              handleChange(e);
                            }}
                            maxLength={1000}
                            disabled={
                              !canEditCase &&
                              (!isEditable || isRegister || view_Case)
                            }
                          />
                        </Col>
                      </Row>

                      <hr />
                      <Row className="mt-3">
                        <Col className="d-flex justify-content-end">
                          <Button
                            variant="outline-info"
                            className="d-flex align-items-center"
                            onClick={() => resetForm()}
                            disabled={!dirty || !isEditable || view_Case}
                          >
                            <span className="material-icons mr-2">close</span>{" "}
                            Cancel
                          </Button>
                          {isEditable ? (
                            <Button
                              type="submit"
                              variant="primary"
                              className="d-flex align-items-center mx-2"
                              onClick={() => setIsRegisterButton(false)}
                              disabled={
                                !canEditCase &&
                                (!dirty ||
                                  !isEditable ||
                                  isRegister ||
                                  view_Case)
                              }
                            >
                              <span className="material-icons mx-1">save</span>{" "}
                              Save
                            </Button>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </>
                  ),
                },
              ])}

              <Row className="mb-3 mt-3">
                <Col className="d-flex justify-content-start">
                  {userData?.caseInfoId ? (
                    <>
                      <Button
                        variant="outline"
                        className="d-flex align-items-center btn-text-border me-1"
                        onClick={handleNavigationBack}
                        disabled={!userData?.caseInfoId}
                      >
                        <span className="material-icons mr-2 ">arrow_back</span>
                        Back
                      </Button>

                      <OverlayTrigger
                        show={showTooltip}
                        placement="auto"
                        trigger={["hover", "focus"]} // Important to prevent sticky tooltip
                        delay={{ show: 200, hide: 100 }}
                        overlay={
                          <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                            Logs
                          </Tooltip>
                        }
                      >
                        <button
                          type="button"
                          className="btn btn-primary d-flex align-items-center mx-2"
                          onClick={handleOpenDrawer}
                          onMouseEnter={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}
                          disabled={!userData?.caseInfoId}
                        >
                          <span className="material-icons">description</span>
                        </button>
                      </OverlayTrigger>
                    </>
                  ) : (
                    ""
                  )}
                  {/* {isEditable ? (
                    <Button
                      type="submit"
                      variant="primary"
                      className="ml-3 d-flex align-items-center ms-1"
                      disabled={
                        // !caseSubjectId ||
                        // stakeholderId == null ||
                        // stakeholderId == undefined ||
                        // stakeholderId == "" ||
                        isRegister || view_Case
                      }
                      onClick={() => setIsRegisterButton(true)}
                    >
                      <span className="material-icons mx-1">save</span> Register
                      Case
                    </Button>
                  ) : (
                    ""
                  )} */}
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </Container>
      <OverlayDrawer
        title={"Logs"}
        open={drawerOpen}
        onClose={handleCloseDrawer}
        placement="bottom"
      >
        <DataTable
          headers={GENERAL_LOG_HEADERS}
          rows={logdata}
          isLogTable={true}
        />
      </OverlayDrawer>
      <Snackbar
        open={snackbarOpen}
        message={snackbarMessage}
        onClose={() => setSnackbarOpen(false)}
        severity={error}
      />
    </div>
  );
};

export default Header;
